<app-standard-page>
  <div class="card vertical ms-0 container p-0">
    @if (registers) {
      <div class="body-container">
        <div class="card-body fs-4" [class.minimised]="!isMinimised">
          <div class="row">
            <div class="col-12 col-lg-6">
              <h1 class="text-primary">Get started</h1>
            </div>
            <div
              class="col-12 col-lg-6 d-flex justify-content-end align-items-end"
            >
              <button
                type="button"
                class="btn btn-outline"
                (click)="isMinimised = false"
              >
                <i-lucide name="chevron-down"></i-lucide>
                Show
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="body-container">
        <div class="card-body fs-4" [class.minimised]="isMinimised">
          <div class="row">
            <div class="col-12 col-lg-6"></div>
            <!-- Depreciation intro -->
            @if (status === StartStatus.SetupDepreciation) {
              <h3>Let's automate your fixed asset depreciation.</h3>
            }

            <!-- Firm intro -->
            @if (status === StartStatus.SetupFirm) {
              <h3>
                FinQuery Fixed Assets is sophisticated enough for Tier 1
                practices, and user-friendly enough for sole practitioners.
              </h3>
            }

            @if (isNewAndConnectedToPrimaryIntegration) {
              <p class="mt-4 mb-0">
                You've already created an Asset Register and connected it to
                your
                {{ integrationName }} account.
              </p>
            }
          </div>
        </div>

        <div class="row m-2">
          <div class="col-12 col-lg-6 d-flex flex-column justify-content-end">
            <app-reviews [status]="status"></app-reviews>

            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn btn-outline"
                (click)="isMinimised = true"
              >
                <i-lucide name="chevron-up"></i-lucide>
                Hide
              </button>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <app-loading></app-loading>
    }
  </div>
</app-standard-page>
